import { ApiModel } from 'base'

export default class ParkReservation extends ApiModel {
  get key() { return `${this.place_id}/${this.date}/${this.time}` }
  get isApproved() { return this.state == 'approved' }
  get isPending() { return this.state == 'pending' }
}
